import React, { lazy, Suspense } from "react";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { AppContextProvider, useAppContext } from "./context/appContext";
import ErrorBoundary from "./components/ErrorBoundary";

const Chat = lazy(() => import("./components/Chat"));

function ChakraWithThemeData() {
  const { theme } = useAppContext();

  const defaultFontFamily = `-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif`;

  const customTheme = extendTheme({
    fonts: {
      body: theme?.font_family || defaultFontFamily,
      heading: theme?.font_family || defaultFontFamily,
    },
    fontSizes: {
      xs: "12px",
      sm: "14px",
      md: "16px",
      lg: "18px",
      xl: "20px",
    },
    styles: {
      global: {
        ".brarista-chat-container": {
          fontFamily: theme?.font_family || defaultFontFamily,
          "& *": {
            fontFamily: "inherit",
          },
          "--default-fs": theme?.font_size || "12px",
        },
        // to override the global style from Emotion
        // library which sets display for image to block
        ":where(img)": {
          display: "unset",
        },
      },
    },
  });

  return (
    <ChakraProvider theme={customTheme} resetCSS={true}>
      <Suspense fallback={<div>Loading chat...</div>}>
        <div className="brarista-chat-container">
          <Chat />
        </div>
      </Suspense>
    </ChakraProvider>
  );
}

function App({ config }) {
  return (
    <ErrorBoundary>
      <AppContextProvider config={config}>
        <ChakraWithThemeData />
      </AppContextProvider>
    </ErrorBoundary>
  );
}

export default App;
